<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>My Saved Reports</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn @click="NewReport()" slot="activator" color="primary" dark class="mb-2">New Report</v-btn>
        <span>Create a New Report</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table flat :headers="calcHeaders" :items="rentalCalcs" class="elevation-1" hide-actions>
      <template v-slot:items="props">
        <td>{{ props.item.data().reportName }}</td>
        <td class="text-xs-left">{{ props.item.data().description }}</td>
        <td class="text-xs-left">{{ props.item.data().timestamp | usDate }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip bottom>
            <v-icon @click="EditReport(props.item)" slot="activator" small class="mt-3 mr-2">
              edit
            </v-icon>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-icon @click="DeleteReport(props.item)" slot="activator" small class="mt-3 mr-2">
              delete
            </v-icon>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        NO REPORTS FOUND
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import db from '../../firebaseInit';

  export default {
    name: 'RentalCalcList',
    data: () => ({
      rentalCalcs: [],
      calcHeaders: [
        { text: 'Report Name', value: 'reportName', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Created On', value: 'timestamp', sortable: false },
        { text: 'Actions', align: 'center', sortable: false  }
      ]
    }),
    methods: {
      NewReport(){
        this.$store.commit('setSelectedRentalCalc', '');
        this.$router.push({ path: `/RentalCalc` });
      },
      EditReport(item) {
        //set the selected report
        this.$store.commit('setSelectedRentalCalc', item.id);
        this.$router.push({ path: `/RentalCalc` });
      },
      DeleteReport(item) {
        db.collection("rentAnalysis").doc(item.id).delete().then(function() {
            console.log("Document successfully deleted!");
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });
        this.GetReports();
      },
      GetReports(){
        db.collection("rentAnalysis").where("userName", "==", this.userName).get().then((querySnapshot) => {
          this.rentalCalcs = querySnapshot.docs;  
        });
      }
    },
    computed: {
      userName(){
        return this.$store.state.user.userName;
      }
    },
    created: function() {
      this.rentalCalcs = [];
      this.GetReports();
    }
  }
</script>

<style scoped>
</style>